// Set up your application entry point here...
import { AppContainer } from 'react-hot-loader';
import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';
import { history } from './store/configureStore';
import Store from './store/Store';
import 'typeface-rubik';
import 'typeface-roboto';
import * as Sentry from '@sentry/browser';
import Root from './components/Root';
import moment from 'moment-timezone';

// SENTRY PRODUCTION OR DEVELOPMENT
process.env.REACT_APP_SENTRY_DSN
  ? Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN })
  : console.log('* APP IN TESTING *');

moment.tz.setDefault('UTC');

render(
  <AppContainer>
    <Root store={Store} history={history} />
  </AppContainer>,
  document.getElementById('app')
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
      <AppContainer>
        <NewRoot store={Store} history={history} />
      </AppContainer>,
      document.getElementById('app')
    );
  });
}
